import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getRequest } from '../../requestUtils';
import searchIcon from '../../../assets/images/search-icon-white.svg';
import RecommendedConsultantCard from '../RecommendedConsultantCard';
import Loading from '../common/Loading';
import './ConsultantSearchContainer.scss';

function ConsultantSearchContainer({
  consultants: initialConsultants, searchUrl, csrfToken,
  email, cloraEmployer, googleOmniauthUrl,
  msOmniauthUrl, signInUrl,
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [consultants, setConsultants] = useState(initialConsultants);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = useCallback(() => {
    if (!searchQuery.trim()) return;
    setIsSearching(true);

    getRequest(`${searchUrl}?query=${encodeURIComponent(searchQuery)}`, csrfToken)
      .then(({ data }) => {
        setConsultants(data);
        setIsSearching(false);
      })
      .catch(() => setIsSearching(false));
  }, [searchQuery, searchUrl, csrfToken]);

  const handleClearSearchInput = () => {
    setSearchQuery('');
    setConsultants([]);
  };

  return (
    <div className="consultant-search-container d-flex flex-column w-100 h-100 p-3 gap-4 rounded-3">
      <div className="search-header d-flex flex-column w-100 h-100 p-5 gap-4 rounded-3">
        <h1 className="text-center mb-3">Consultant Search</h1>
        <div className="input-with-symbol">
          <input
            type="text"
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearch();
            }}
            value={searchQuery}
            placeholder="Enter search query"
          />
          {searchQuery && (
            <i className="fa fa-times clear-btn" role="button" tabIndex={0} onClick={handleClearSearchInput} />
          )}
          <span role="button" tabIndex={0} onClick={handleSearch} disabled={!searchQuery.trim()}>
            <img src={searchIcon} alt="search icon" />
          </span>
        </div>
      </div>

      <div className="search-results d-flex flex-column justify-content-center w-100 h-100 gap-4 rounded-3">
        {isSearching ? (
          <Loading />
        ) : consultants.length > 0 ? (
          <div className="cards mb-3 justify-content-center gap-3">
            {consultants.map((consultant) => (
              <RecommendedConsultantCard
                consultant={consultant}
                getEmailStatus={() => email}
                csrfToken={csrfToken}
                cloraEmployer={cloraEmployer}
                googleOmniauthUrl={googleOmniauthUrl}
                msOmniauthUrl={msOmniauthUrl}
                signInUrl={signInUrl}
              />
            ))}
          </div>
        ) : (
          <div className="no-results text-center bg-white rounded-3 p-5 fs-5">
            Enter a search query to begin searching.
          </div>
        )}
      </div>
    </div>
  );
}

ConsultantSearchContainer.propTypes = {
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default ConsultantSearchContainer;
